import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_APPLICATION_ACTION_TYPE } from '../actions';

// The ids of the loan's HIDDEN completeness checklists — the only checklists allowed to drive the
// in-editor "Needed" highlighting (DEV-4603). Empty until the loan-scoped read resolves, so no
// highlighting fires before the completeness set is known (avoids a flash of the pre-fix all-checklist
// false flags).
const initialState = [];

const completenessChecklistIdsReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case LOAN_APPLICATION_ACTION_TYPE.GET_COMPLETENESS_CHECKLIST_IDS:
        return payload || initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default completenessChecklistIdsReducer;
